const DemoContent = {
    content: [
        {
            name: 'KEYWORDS',
            title: 'TOPICS_AND_KEYWORDS',
            description: 'KEYWORDS_DESCRIPTION',
            text: 'KEYWORDS_TEXT',
            image: 'KEYWORDS'
        },
        {
            name: 'TOPIC_COMPARISON',
            title: 'TOPIC_COMPARISON',
            description: 'TOPIC_COMPARISON_DESCRIPTION',
            text: 'TOPIC_COMPARISON_TEXT',
            image: 'TOPIC_COMPARISON'
        },
        {
            name: 'SAMPLE',
            title: 'SAMPLE',
            description: 'SAMPLE_DESCRIPTION',
            text: 'SAMPLE_TEXT',
            image: 'SAMPLE'
        },
        {
            name: 'EXTENDED_ANALYTIC',
            title: 'EXTENDED_ANALYTIC',
            description: 'EXTENDED_ANALYTIC_DESCRIPTION',
            text: 'EXTENDED_ANALYTIC_TEXT',
            image: ''
        },
        {
            name: 'REPORTS',
            title: 'REPORTS',
            description: 'REPORTS_DESCRIPTION',
            text: 'REPORTS_TEXT',
            image: 'EXTENDED_ANALYTIC'
        },
        {
            name: 'DASHBOARDS',
            title: 'DASHBOARDS',
            description: 'DASHBOARDS_DESCRIPTION',
            text: 'DASHBOARDS_TEXT',
            image: 'DASHBOARDS'
        },
        {
            name: 'NOTIFICATIONS',
            title: 'NOTIFICATIONS',
            description: 'NOTIFICATIONS_DESCRIPTION',
            text: 'NOTIFICATIONS_TEXT',
            image: 'NOTIFICATIONS'
        }
    ]
}

export default DemoContent;